import { STATE } from '@funnels/constants';
import { Address } from '@funnels/types';

export const ADDRESS1: Address = {
  postcode: '2000',
  state: STATE.NSW,
  formatted: '9/37 Pitt Street, Sydney, 2000, NSW',
  city: 'sydney',
  standard: {
    streetName: 'Pitt',
    streetNumber: '37',
    streetType: 'street',
    level: '9',
    unit: undefined,
  },
};

export const ADDRESS2: Address = {
  postcode: '2000',
  state: 'NSW',
  formatted: '199 George St, Sydney NSW 2000',
  city: 'sydney',
  country: 'Australia',
  standard: {
    streetName: 'George',
    streetNumber: '199',
    streetType: 'Street',
  },
};

export const ADDRESS3: Address = {
  postcode: '2000',
  state: 'NSW',
  formatted: '100 George St, Sydney NSW 2000',
  city: 'sydney',
  country: 'Australia',
  standard: {
    streetName: 'George',
    streetNumber: '100',
    streetType: 'Street',
  },
};
